import { render } from "./PlanIndividual.vue?vue&type=template&id=53837180&scoped=true"
import script from "./PlanIndividual.vue?vue&type=script&lang=js"
export * from "./PlanIndividual.vue?vue&type=script&lang=js"

import "./PlanIndividual.vue?vue&type=style&index=0&id=53837180&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53837180"

export default script